/**
 * Warehouse Fulfillment & Shipping Zones Domain API Service
 */

import { api } from './client';

export const fulfillmentAPI = {
  // Pick & Pack, Labels, Weight Calculation
  getPickPackList: async (orderIds: number[]) => api.post('/orders/pick_pack_list/', { order_ids: orderIds }),
  getPickPackPDF: async (orderIds: number[]) => api.post('/orders/pick_pack_pdf/', { order_ids: orderIds }, { responseType: 'blob' }),
  generateLabels: async (orderIds: number[], senderInfo?: any) =>
    api.post('/orders/generate_labels/', { order_ids: orderIds, sender_info: senderInfo }, { responseType: 'blob' }),
  calculateWeight: async (data: { actual_weight: number; length: number; width: number; height: number; zone_code?: string; order_id?: number }) =>
    api.post('/orders/calculate_weight/', data),
  getShippingZones: async () => api.get('/orders/shipping_zones/'),
  saveShippingZone: async (data: any) => api.post('/orders/save_shipping_zone/', data),
  deleteShippingZone: async (id: number) => api.post('/orders/delete_shipping_zone/', { id }),
};
